import cn from 'classnames'
import React, { FC } from 'react'

interface Props {
    className?: string
    children?: any
    el?: HTMLElement
    clean?: boolean
    id?: string
}

const Container: FC<Props> = ({
    children,
    className,
    el = 'div',
    clean,
    id
}) => {
    const rootClassName = cn(className, {
        'mx-auto max-w-8xl px-6': !clean
    })

    const Component: React.ComponentType<
        React.HTMLAttributes<HTMLDivElement>
    > = el as any

    return (
        <Component id={id} className={rootClassName}>
            {children}
        </Component>
    )
}

export default Container
